// @ts-ignore
import fontFaceCss from './font-face.base64css';
import cssImports from './imports.json' assert { type: 'json' };
import { defaultBase } from './links/constants';
import { createFilter } from './links/create-filter';
import { getMediaQuery } from './links/get-media-query';
import type { LinkProps, LinksFunction } from './links/types';

export const links: LinksFunction = ({ base = defaultBase, filter } = {}) => {
  if (base && typeof base !== 'string') {
    base = base.href;
  }
  if (typeof base === 'string' && base !== '' && !base.endsWith('/')) {
    base += '/';
  }
  const linkProps = Object.entries(cssImports)
    .filter(createFilter(filter))
    .flatMap(([name, filename]) => {
      const props: LinkProps = {
        href: base + filename,
        rel: 'stylesheet',
        crossOrigin: 'anonymous',
      };
      const media = getMediaQuery(name);
      if (media) {
        props.media = media;
      }

      const preloadProps = {
        ...props,
        rel: 'preload',
        as: 'style',
      };

      props['data-volvo-css-name'] = name;

      // Return @font-face rules as base64 encoded inline CSS to start downloading fonts earlier,
      // improving LCP.
      if (name === 'font-face.css' && filter?.preload !== false) {
        return {
          ...props,
          href: `data:text/css;base64,${fontFaceCss}`,
        };
      }
      if (filter?.preload === false) {
        return props;
      } else {
        return [preloadProps, props] as const;
      }
    })
    .sort((a, b) =>
      a.rel === 'preload' && b.rel === 'preload'
        ? 0
        : a.rel === 'preload'
        ? -1
        : 1
    ) as LinkProps[];

  linkProps.toString = function toString() {
    let html = '';
    for (const link of this) {
      const attrs = Object.entries(link)
        .map(([key, value]) => `${key}="${value}"`)
        .join(' ');
      html += `<link ${attrs} />\n`;
    }
    return html;
  };

  return linkProps;
};

export type { LinksFunction, LinkProps };
